import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { SbCodeComponent } from './sb-code.component';
import { SbCodePipe } from './sb-code.pipe';

const COMPONENTS = [
  SbCodeComponent,
];

const PIPES = [
  SbCodePipe,
];

@NgModule({
  declarations: [
    COMPONENTS,
    PIPES,
  ],
  exports: [
    COMPONENTS,
    PIPES,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
})
export class SbCodeModule { }
